import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider } from '@getgo/chameleon-material-ui';
import { ThemeProvider as WebThemeProvider } from '@getgo/chameleon-web/react';
import { useEffect } from 'react';
// Chameleon web theme provider is missing a height 100% which prevent keeping the browser height
// on children
const HEIGHT = {
    height: '100%',
};
export const WithThemeProvider = ({ children, isGTC = false, isAllowedToChangeTheme = false, prefix, rebranding2021, theme, skin, height = HEIGHT, }) => {
    // these hooks change the theme settings on the chameleon-theme-provider provided by shell
    useEffect(() => {
        if (isGTC && isAllowedToChangeTheme) {
            document.querySelector('chameleon-theme-provider').setAttribute('theme', theme);
            document
                .querySelector('body')
                .setAttribute('class', theme === 'dark' ? 'theme-dark' : 'theme-light');
        }
    }, [isGTC, isAllowedToChangeTheme, theme]);
    useEffect(() => {
        if (isGTC && isAllowedToChangeTheme) {
            document.querySelector('chameleon-theme-provider').setAttribute('skin', skin);
        }
    }, [isGTC, isAllowedToChangeTheme, skin]);
    useEffect(() => {
        if (isGTC && isAllowedToChangeTheme) {
            if (rebranding2021) {
                document.querySelector('body').setAttribute('rebranding2021', '');
                document.querySelector('chameleon-theme-provider').setAttribute('rebranding2021', '');
            }
            else {
                document.querySelector('chameleon-theme-provider').removeAttribute('rebranding2021');
                document.querySelector('body').removeAttribute('rebranding2021');
            }
        }
    }, [isGTC, isAllowedToChangeTheme, rebranding2021]);
    if (isGTC) {
        return (_jsx(ThemeProvider, Object.assign({ classNamePrefix: prefix }, (isAllowedToChangeTheme && { theme }), { children: children }), void 0));
    }
    // this theme provider is user for storybook and legacy admin
    return (_jsx(WebThemeProvider, Object.assign({ skin: skin, theme: theme, style: height, prefix: prefix, rebranding2021: rebranding2021 }, { children: _jsx(ThemeProvider, Object.assign({ theme: theme, classNamePrefix: prefix }, { children: children }), void 0) }), void 0));
};
//# sourceMappingURL=providers.js.map